import {appPrefix, init} from '@ebexco/core/src/bootstrap';
import {conf} from '@ebexco/core/src/services/conf';
import {urlParams} from '@ebexco/core/src/utils/urls';
import {cssExt, jsExt} from '@ebexco/core/src/utils/extensions';
import {dataset} from '@ebexco/core/src/ponyfills/dataset';
import {featureToggle} from '../src/feature-toggles';
import {experience} from '../src/experience';
import {getAbTest} from '../src/ab-test';

const context = document.getElementById('cvly-js');
const data = context ? dataset(context) : {};

featureToggle(conf.appName);

/**
 * @return {object} options
 */
function getOpts() {
  return {
    scripts: [
      conf.baseUrl + appPrefix + conf.app + jsExt,
    ],
    styles: [
      conf.baseUrl + appPrefix + conf.app + cssExt,
    ],
  };
}

function loadLegacyConvincely() {
  experience.set(false);

  const opts = getOpts();

  init(opts);
}

async function loadConvincely() {
  experience.set(false);

  const experiment = urlParams.cvlyexp || data.feature || await getAbTest();

  if (experiment) {
    conf.feature = experiment;
    experience.set(conf.feature);
  }

  const opts = getOpts();
  init(opts);
}

if (window.document.documentMode) {
  loadLegacyConvincely();
} else {
  loadConvincely();
}
